// auth.service.ts
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IPageAPIResource } from '../../models/web/IPageApiResource';
import { AuthWebService } from './auth-web.service';

@Injectable({
	providedIn: 'root'
})
export class GetPaginaWebService {
	private http = inject(HttpClient);
	private authService = inject(AuthWebService);
	token = this.authService.obtenerToken();
	getPage(slug: string) {
		const headers = new HttpHeaders({
			Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
			'Content-Type': 'application/json'
		});

		return this.http.get<IPageAPIResource>(`${environment.apiWebUrl}/paginas/${slug}`, { headers });
	}
}
